'use client';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { useSiteId } from '@/contexts/domain/hooks';
import { useSetCookie } from '@/hooks/use-cookies';
import { Link, useRouter } from '@/navigation';
import { Cookie } from '@/types/storage';
import { GlobeSimple } from '@phosphor-icons/react';
import { useLocale, useTranslations } from 'next-intl';
import Image from 'next/image';
import eeFlag from 'public/images/flag/flag-ee.svg';
import lvFlag from 'public/images/flag/flag-lv.svg';
import { useTransition } from 'react';

export const LanguageChange = () => {
  const locale = useLocale();

  const siteId = useSiteId();
  const t = useTranslations('navigation');
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const setCookie = useSetCookie();
  const targetLocale = locale.includes('ru')
    ? locale.split('-')[1]
    : `ru-${locale}`;

  const handleClick = () => {
    startTransition(() => {
      setCookie(Cookie.NEXT_LOCALE, targetLocale);
      router.refresh();
    });
  };

  //This component for now should be visible only on Estonian and Latvian
  if (siteId !== 'kg_ee' && siteId !== 'ds_lv') return null;

  const countryFlag = siteId === 'kg_ee' ? eeFlag : lvFlag;
  const countryImageAlt = siteId === 'kg_ee' ? 'ee flag' : 'lv flag';

  return (
    <Link
      aria-disabled={isPending}
      className="flex h-full items-center px-xxs text-default text-small xl:order-2"
      onClick={(e) => {
        e.preventDefault();
        handleClick();
      }}
      href="#"
    >
      <div className="flex w-full items-center gap-3 border-decorative border-b-1">
        <PhosphorIcon
          Icon={GlobeSimple}
          variant="bold"
          color="default"
          className="icon-xs"
        />
        {t('information_section.switch_language')}
        {/* We don't want to show ru flag */}
        {locale.includes('ru') && (
          <Image
            alt={countryImageAlt}
            src={countryFlag}
            width={24}
            height={18}
          />
        )}
      </div>
    </Link>
  );
};
